import React, { PureComponent } from 'react';

import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

export default class NumberEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
  }

  render() {
    return (
      <input
        title={this.props.tooltip || ''}
        className="pwx-number-editor"
        disabled={this.props.disabled}
        height={this.props.height}
        name={this.props.name}
        type="number"
        value={this.props.value}
        onChange={this.onControlValueListener}
        style={{ width: CoreUtils.isDefinedAndNotNull(this.props.width) ? this.props.width : '65px' }}
      />
    );
  }

  onControlValueChanged(event) {
    var value = event.currentTarget.valueAsNumber;
    if (StringUtils.isEmptyString(event.currentTarget.value))
      value = null;

    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}